var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 800 800",
    width: "48px",
    height: "48px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    cx: "50%",
    cy: "50%",
    r: "50%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150, 200)",
    d: "M485.384 47.3227C467.571 55.216 448.435 60.5493 428.317 62.96C449.075 50.5396 464.604 30.9913 472.008 7.96267C452.506 19.5464 431.162 27.7002 408.904 32.0693C393.936 16.0878 374.111 5.49496 352.506 1.93545C330.901 -1.62406 308.725 2.04889 289.421 12.3841C270.117 22.7192 254.766 39.1384 245.75 59.0923C236.734 79.0463 234.558 101.419 239.56 122.736C200.044 120.752 161.387 110.481 126.097 92.59C90.8074 74.6989 59.674 49.5874 34.7174 18.8853C26.184 33.6053 21.2774 50.672 21.2774 68.848C21.2679 85.2106 25.2973 101.323 33.0081 115.754C40.719 130.186 51.8728 142.491 65.48 151.579C49.6993 151.077 34.2667 146.812 20.4667 139.141V140.421C20.4651 163.37 28.4034 185.613 42.9346 203.376C57.4658 221.138 77.6949 233.326 100.189 237.872C85.5501 241.834 70.2019 242.417 55.304 239.579C61.6507 259.325 74.0133 276.593 90.6612 288.964C107.309 301.335 127.409 308.19 148.147 308.571C112.943 336.206 69.467 351.197 24.712 351.131C16.7842 351.133 8.86301 350.67 0.98938 349.744C46.4182 378.953 99.3006 394.455 153.309 394.395C336.136 394.395 436.083 242.971 436.083 111.643C436.083 107.376 435.976 103.067 435.784 98.8C455.225 84.7408 472.006 67.3311 485.341 47.3867L485.384 47.3227Z",
    x: 500,
    y: 500,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter.121eb0a6.svg";
export { ForwardRef as ReactComponent };